import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Copyright (c) Openizr. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
import React from "react";
import { buildClass, UIButton } from "biuty/react";
import { useCombiner, closeModal } from "@root/store";
/**
 * App modal.
 */
function Modal({ components }) {
    const modal = useCombiner('routedModal');
    const handleClose = React.useCallback(() => {
        closeModal(modal.queryParam, modal.queryValue);
    }, [modal.queryParam, modal.queryValue]);
    const currentContent = React.useMemo(() => {
        if (modal.show) {
            const ComponentName = components[modal.component];
            const props = { ...modal.componentProps };
            if (modal.queryParam !== null) {
                props[modal.queryParam] = modal.queryValue;
            }
            return _jsx(ComponentName, { onClose: handleClose, ...props });
        }
        return null;
    }, [modal]);
    const handleKeyUp = React.useCallback((event) => {
        if (event.key === "Escape" && currentContent !== null) {
            handleClose();
        }
    }, [handleClose, currentContent]);
    // Handles special keys like Escape to control modal.
    React.useEffect(() => {
        window.addEventListener("keyup", handleKeyUp);
        return () => {
            window.removeEventListener("keyup", handleKeyUp);
        };
    }, [handleKeyUp]);
    const className = buildClass("modal", currentContent !== null ? "visible" : "");
    return (_jsxs("div", { className: className, children: [_jsx("div", { className: "modal__dimmer" }), _jsxs("div", { className: "modal__content", children: [_jsx("div", { className: "modal__content__close-button", children: _jsx(UIButton, { icon: "close", onClick: handleClose }) }), currentContent] })] }));
}
export default React.memo(Modal);
